import { KeyValue } from 'ngrx-forms';

import { Params } from '@angular/router';
import { Dictionary } from '@ngrx/entity';
import { createSelector } from '@ngrx/store';

import { LazyEntitySelectors, LazyEntityState } from './models';

export function createSelectorsFactory<T, K extends KeyValue>() {
  function getSelectors(
    selectEntities: (state: any) => Dictionary<T>,
    selectQueryParams: (state: any) => Params,
    selectState: (state: any) => LazyEntityState<T, K>
  ): LazyEntitySelectors<T, LazyEntityState<T, K>, K> {
    const selectEntityForm = createSelector(
      selectState,
      (state: LazyEntityState<T, K>) => state.entityForm
    );

    const selectEntityId = createSelector(
      selectState,
      (s: LazyEntityState<T, K>) => s.selectedId as number
    );

    const isNew = createSelector(
      selectState,
      (s: LazyEntityState<T, K>) => (s.selectedId as number) === 0
    );

    const getSelectedEntity = createSelector(
      selectEntityId,
      selectEntities,
      (id, entities) => {
        return id != null ? entities[id] : undefined;
      }
    );

    const selectEntityFilterForm = createSelector(
      selectState,
      (s: LazyEntityState<T, K>) => s.entityFilterForm
    );

    const getGridState = createSelector(
      selectState,
      (s: LazyEntityState<T, K>) => s.gridState
    );

    const getPageSize = createSelector(
      selectState,
      (s: LazyEntityState<T, K>) => s.gridState.pageSize
    );

    const getCurrentPage = createSelector(
      selectState,
      (s: LazyEntityState<T, K>) => s.gridState.currentPage
    );

    const getTotalRows = createSelector(
      selectState,
      (s: LazyEntityState<T, K>) => s.gridState.totalRows
    );

    const pageLoaded = createSelector(
      selectState,
      (s: LazyEntityState<T, K>) => s.gridState.pageLoaded
    );

    const getColumnState = createSelector(
      selectState,
      (s: LazyEntityState<T, K>) => s.gridState.columnState
    );

    const getFilterModel = createSelector(
      selectState,
      (s: LazyEntityState<T, K>) => s.gridState.filterModel
    );

    const getLoadedEntity = createSelector(
      selectState,
      (s: LazyEntityState<T, K>) => s.loadedEntity
    );

    const showAdvancedFilters = createSelector(
      selectState,
      (s: LazyEntityState<T, K>) => s.showAdvancedFilters
    );

    return {
      selectEntityForm,
      selectEntityId,
      isNew,
      selectEntityFilterForm,
      getSelectedEntity,
      getGridState,
      getColumnState,
      getCurrentPage,
      getFilterModel,
      getLoadedEntity,
      getPageSize,
      getTotalRows,
      pageLoaded,
      showAdvancedFilters,
      getQueryParams: selectQueryParams,
    };
  }

  return { getSelectors };
}
